document.addEventListener("click", function (event) {
  const chooseTrigger = event.target.closest(".choose_btn_cstm ");
  const addTrigger = event.target.closest(".addCard_btn");

  // If neither button clicked → exit
  if (!chooseTrigger && !addTrigger) return;

  event.preventDefault();

  const triggerBtn = chooseTrigger || addTrigger;
  const productCard = triggerBtn.closest(".product-card__content");
  if (!productCard) return;

  const quickAdd = productCard.querySelector("quick-add-component");
  if (!quickAdd) return;

  // USER CLICKED CHOOSE BUTTON
  if (chooseTrigger) {
    const chooseBtn = quickAdd.querySelector(".quick-add__button--choose");
    if (chooseBtn) {
      console.log("Choose button clicked");
      chooseBtn.click();
    }
  }

  // USER CLICKED ADD TO CART BUTTON
  if (addTrigger) {
    const addBtn = quickAdd.querySelector(".quick-add__button--add");
    if (addBtn) {
      console.log("Add to cart button clicked");
      addBtn.click();
    }
  }
});
document.addEventListener("DOMContentLoaded", function () {

  var footer = document.querySelector(".mobile_sticky_footer");
  var lastScroll = 0;

  window.addEventListener("scroll", function () {

    if (window.innerWidth > 768) {

      let currentScroll = window.scrollY;

      if (currentScroll > lastScroll && currentScroll > 150) {
        footer.classList.add("show-footer");
      } else {
        footer.classList.remove("show-footer");
      }

      lastScroll = currentScroll;
    }

  });

});